
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.417 15.139c2.818-3.166 7.27-5.207 11.173-5.137a.419.419 0 01.407.406c.09 3.9-1.966 8.351-5.135 11.176a10.555 10.555 0 01-3.058 7.22.47.47 0 01-.323.135.382.382 0 01-.119-.019c-.15-.05-.272-.165-.295-.321l-.46-3.212-.444.396a.415.415 0 01-.572-.015l-5.355-5.357a.417.417 0 01-.017-.572l.397-.445-3.211-.46a.417.417 0 01-.233-.709 10.572 10.572 0 017.245-3.086zm5.86 2.666c.534 0 1.068-.203 1.473-.61a2.086 2.086 0 000-2.946 2.085 2.085 0 00-2.946 0 2.088 2.088 0 000 2.947c.406.406.94.61 1.473.61zm-14.26 11.658c.137-.456 1.361-4.484 2.253-5.376a2.578 2.578 0 013.641 0 2.58 2.58 0 010 3.643c-.891.892-4.919 2.116-5.374 2.253a.416.416 0 01-.52-.52z","fill":"#E7E5EC"}})])
          )
        }
      }
    